import { Box } from "@mui/material";
import ValidationAllocationCreate from "pages/product_validation/validationAllocation/ValidationAllocationCreate";
import React, { useEffect } from "react";
import ValidationAllocationList from "pages/product_validation/validationAllocation/ValidationAllocationList";

const ValidationAllocation = ({
  product,
  fullGrid = false,
  completed = null,
}) => {
  useEffect(() => {
    console.log("Pr", product);
  }, [product]);
  return (
    <Box padding={2}>
      <ValidationAllocationList product_id={product?.id} fullGrid={fullGrid}/>
      <ValidationAllocationCreate
        fullGrid={fullGrid}
        product_id={product?.id}
      />
    </Box>
  );
};

export default ValidationAllocation;
